import FramedImage from './FramedImage';

let PIXI;
if (typeof window !== 'undefined') {
  PIXI = require('pixi.js');
}

class PixiSlide {
  constructor(
    track,
    imgSrc,
    app,
    index,
    loadCallback,
    focalX = 0.5,
    focalY = 0.5
  ) {
    // create the slide
    // set position based on Index
    this.index = index;
    this.container = new PIXI.Container();
    this.framedImage = new FramedImage(app, imgSrc, false, focalX, focalY);
    this.loaded = false;
    this.framedImage.load().then(() => {
      this.loaded = true;
      this.framedImage.drawAtSliderSize();
      this.container.addChild(
        this.framedImage.mask,
        this.framedImage.imgContainer
      );
      track.addChild(this.container);
      this.setSlidePosition();
      if (loadCallback) {
        loadCallback();
      }
    });
  }
  updateSize = () => {
    if (!this.loaded) return;
    this.framedImage.drawAtSliderSize();
    this.setSlidePosition();
  };
  contract(reverse, duration) {
    // shrunken size while panning
    this.framedImage.contract(reverse, duration);
  }
  expand(duration) {
    // slider size
    this.framedImage.expand(duration);
  }
  fullOpen() {
    // open slider
  }
  chapterOpen(onComplete) {
    // from slide position to full screen
    this.framedImage.chapterOpenPan(() => {
      // after chapter renders, go back to where you were
      if (onComplete) {
        onComplete(this.updateSize);
      } else {
        setTimeout(() => {
          this.updateSize();
        }, 1000);
      }
    }, 0.4);
  }
  setSlidePosition() {
    this.container.position.x = this.index * window.innerWidth;
  }
  hide() {
    this.container.visible = false;
  }
  show() {
    this.container.visible = true;
  }
  destroy() {
    this.container.destroy({ children: true });
  }
}

export default PixiSlide;



// WEBPACK FOOTER //
// ./src/components/pixi/PixiSlide.js